<p-card>
  @if (module(); as module) {
    <div class="module-info__head">
      <span class="module-info__icon"><i [class]="module.manifest?.icon ?? 'pi pi-box'"></i></span>
      <div>
        <h1 class="module-info__title">
          {{ (module.manifest?.titleKey ?? module.id) | translate }}
        </h1>
        <p class="module-info__subtitle">{{ 'module.info.title' | translate }}</p>
      </div>
    </div>

    <dl class="module-info__list">
      <dt>{{ 'module.license.info.module' | translate }}</dt>
      <dd>
        {{ (module.manifest?.titleKey ?? module.id) | translate }}
        <span class="module-info__guid">({{ module.id }})</span>
      </dd>

      <dt>{{ 'module.info.version' | translate }}</dt>
      <dd>{{ module.manifest?.version ?? '—' }}</dd>

      <dt>{{ 'module.info.shellVersion' | translate }}</dt>
      <dd>{{ shellVersion }}</dd>

      @if (companies.activeCustomerName(); as customerName) {
        <dt>{{ 'module.license.info.customer' | translate }}</dt>
        <dd>{{ customerName }}</dd>
      }

      <dt>{{ 'module.license.info.company' | translate }}</dt>
      <dd>{{ companies.activeCompanyName() ?? '—' }}</dd>

      <dt>{{ 'module.license.info.state' | translate }}</dt>
      <dd>
        <span class="module-info__pill module-info__pill--{{ licenseState() }}">
          {{ 'module.license.' + licenseState() + '.label' | translate }}
        </span>
      </dd>

      @if (catalog(); as entry) {
        <dt>{{ 'module.info.umcModule' | translate }}</dt>
        <dd>
          {{ entry.moduleLabel }} · {{ entry.moduleCode }}
          <span class="module-info__guid">({{ entry.modulePublicId }})</span>
        </dd>

        @if (licence(); as licence) {
          <dt>{{ 'module.info.license' | translate }}</dt>
          <dd>
            {{ licence.licenseName ?? '—' }}
            @if (licence.licensePublicId; as licenceId) {
              <span class="module-info__guid">({{ licenceId }})</span>
            }
          </dd>

          <dt>{{ 'module.license.info.licStatus' | translate }}</dt>
          <dd>{{ licence.licenseStatus }}</dd>

          <dt>{{ 'module.license.info.coverage' | translate }}</dt>
          <dd>
            @if (licence.assignmentMode === 'users') {
              {{
                'module.license.info.seats'
                  | translate: { used: licence.seatsUsed ?? 0, limit: licence.seatsLimit ?? '∞' }
              }}
            } @else {
              {{ 'module.license.info.entireCompany' | translate }}
            }
          </dd>

          @if (licence.startsAt; as from) {
            <dt>{{ 'module.license.info.validFrom' | translate }}</dt>
            <dd>{{ from | date: 'mediumDate' }}</dd>
          }
          @if (licence.expiresAt; as until) {
            <dt>{{ 'module.license.info.validUntil' | translate }}</dt>
            <dd>{{ until | date: 'mediumDate' }}</dd>
          }
        }
      } @else {
        <dt>{{ 'module.info.umcModule' | translate }}</dt>
        <dd>{{ 'module.license.info.noCatalog' | translate }}</dd>
      }
    </dl>

    <p class="module-info__hint">
      {{ 'module.license.' + licenseState() + '.hint' | translate }}
    </p>
  } @else {
    <p>{{ 'module.info.unknown' | translate }}</p>
    <p><code>{{ moduleId() }}</code></p>
  }

  <p-button routerLink="/" [label]="'module.back' | translate" icon="pi pi-arrow-left" />
</p-card>
